module.exports = __webpack_public_path__ + "6172-shadow.8cd3365d21ed0f74918cdd86b66999e6.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6172-shadow.png
// module id = 124
// module chunks = 0